// About Us page images and constants
// Following the same pattern as freelance-income-potential-sections.constant.tsx

import {
  aboutUsHeroImage,
  aboutUsHistoryImage,
  aboutUsVisionImage,
  aboutUsSharePageImage,
  facebookIcon,
  twitterIcon,
  instagramIcon,
  linkedinIcon,
  xIcon,
  downloadIcon,
  documentIcon,
  coins
} from '../components/images/aboutUsImages';

// Main hero title for the page
export const ABOUT_US_MAIN_TITLE = 'ABOUT_US_MAIN_TITLE';

// Image assets for About Us page
export const aboutUsImages = {
  heroImage: aboutUsHeroImage,
  historyImage: aboutUsHistoryImage,
  visionImage: aboutUsVisionImage,
  sharePageImage: aboutUsSharePageImage
};

// Social media icons
export const socialMediaIcons = {
  facebook: facebookIcon,
  twitter: twitterIcon,
  instagram: instagramIcon,
  linkedin: linkedinIcon,
  x: xIcon
};

// Document and UI icons
export const documentIcons = {
  download: downloadIcon,
  document: coins
};

// Content sections for About Us page
export const aboutUsContentSections = [
  {
    titleKey: 'INVOZIO_YOUR_PARTNER_IN_SELF_EMPLOYMENT',
    textKeys: [
      'ABOUT_US_PARTNER_DESCRIPTION'
    ]
  }
];

export const aboutUsSecuritySection = [
  {
    titleKey: 'YOUR_SECURITY_OUR_PRIORITY',
    textKeys: [
      'ABOUT_US_SECURITY_DESCRIPTION_1',
      'ABOUT_US_SECURITY_DESCRIPTION_2'
    ]
  }
];

export const aboutUsCompanyInfoSection = [
  {
    titleKey: 'COMPANY_INFORMATION',
    documentKeys: [
      'F_TAX',
      'AGREEMENT_WITH_SECURE_COLLECTION',
      'INSURANCE_LETTER'
    ]
  }
];

export const aboutUsHistoryVisionSections = [
  {
    titleKey: 'OUR_HISTORY',
    textKeys: [
      'ABOUT_US_HISTORY_DESCRIPTION_1',
      'ABOUT_US_HISTORY_DESCRIPTION_2'
    ]
  },
  {
    titleKey: 'OUR_VISION',
    textKeys: [
      'ABOUT_US_VISION_DESCRIPTION_1',
      'ABOUT_US_VISION_DESCRIPTION_2',
      'ABOUT_US_VISION_DESCRIPTION_3'
    ]
  }
];

export const aboutUsShareSection = [
  {
    titleKey: 'SHARE_OUR_PAGE',
    textKeys: [
      'SHARE_INVOZIO_WITH_FRIENDS',
      'MAXIMIZE_FINANCIAL_GAIN_DESCRIPTION'
    ]
  }
];

// Statistics data - function to be called within component context
export const getAboutUsStatistics = (t: (key: string) => string) => [
  {
    numberKey: t("AMOUNT_INVOICED_STAT_1"),
    labelKey: 'ACTIVE_FREELANCERS'
  },
  {
    numberKey: t("AMOUNT_INVOICED_STAT_2"),
    labelKey: 'JOINED_BUSINESS'
  },
  {
    numberKey: t("AMOUNT_INVOICED_STAT_3"),
    labelKey: 'SATISFIED_CLIENTS'
  },
  {
    numberKey: t("AMOUNT_INVOICED_STAT_4"),
    labelKey: 'SENT_INVOICES'
  }
];
